function fillHidden(hiddenname) {
  // 既存のfillHidden関数のコード
}

var fileInputs = document.querySelectorAll('input[type="file"]');
var totalSize = 0;
var maxTotalSize = 20 * 1024 * 1024; // 20MB

function updateTotalSize() {
    totalSize = 0;
    fileInputs.forEach(function (input) {
        if (input.files[0]) {
        totalSize += input.files[0].size;
        }
    });
    }

    function checkTotalSize() {
    if (totalSize > maxTotalSize) {
        alert(
        "ファイルの合計サイズが20MBを超えています。より小さいファイルを選択してください。"
        );
        return false;
    }
    return true;
    }

    fileInputs.forEach(function (input, index) {
    var fileNameSpan = document.getElementById("file-name" + (index + 1));

    input.addEventListener("change", function (e) {
        var file = e.target.files[0];

        if (file) {
        updateTotalSize();
        if (!checkTotalSize()) {
            this.value = ""; // ファイル選択をクリア
            fileNameSpan.textContent = "画像が選択されていません";
            updateTotalSize(); // 合計サイズを再計算
        } else {
            fileNameSpan.textContent = file.name;
        }
        } else {
        fileNameSpan.textContent = "画像が選択されていません";
        updateTotalSize(); // 合計サイズを再計算
        }
    });
});

// inputのid属性を修正
fileInputs.forEach(function (input, index) {
    input.id = "img" + (index + 1);
    input.nextElementSibling.setAttribute("for", "img" + (index + 1));
});